import * as T from 'io-ts';
export const WaitingVoteT = T.keyof({
    pending: null,
    cast: null,
});
export const FinalizedVoteT = T.keyof({
    red: null,
    amber: null,
    green: null,
});
export const VoteStatusT = T.union([WaitingVoteT, FinalizedVoteT]);
export const VoteT = T.type({ player: T.string, color: VoteStatusT });
export const VoteArrayT = T.array(VoteT);
export const ResultVoteT = T.type({ player: T.string, color: FinalizedVoteT });
export const ResultVoteArrayT = T.array(ResultVoteT);
